import { Helper } from "lumir-back-office-ui";
import { useFormContext } from "react-hook-form";
import CheckboxSelectionControl from "../new-job-announce/checkboxSelectionControl";
import { Terms } from "./terms";
import { useState } from "react";
import { useBodyScrollLock } from "../../../../../hooks/useBodyScrollLock";
const ApplyTerms = ({ name }) => {
  const {
    register,
    formState: { errors },
    watch,
    setValue,
    trigger,
  } = useFormContext();

  const terms = watch(`${name}`);
  const allChecked =
    terms?.personalInfo && terms?.sensitiveInfo && terms?.optionalInfo;
  const [isOpen, setIsOpen] = useState(false);

  const { lockScroll, openScroll } = useBodyScrollLock();

  const handleAllCheck = (checked) => {
    setValue(`${name}`, {
      personalInfo: checked,
      optionalInfo: checked,
      sensitiveInfo: checked,
    });
    trigger([`${name}.personalInfo`, `${name}.sensitiveInfo`]);
  };

  const handleCheckboxChange = async (field, checked) => {
    setValue(field, checked, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
    await trigger(field);
  };

  const handleTermsClick = () => {
    setIsOpen(true);
    lockScroll();
  };

  const handleTermsClose = () => {
    setIsOpen(false);
    openScroll();
  };

  return (
    <>
      {isOpen && <Terms handleTermsClose={handleTermsClose} />}
      <section className="space-y-4 mt-[40px]">
        <div className="space-y-4">
          <div className="flex items-center gap-2 p-sp80">
            <CheckboxSelectionControl
              id={`${name}-total`}
              checked={allChecked}
              onChange={handleAllCheck}
              label="전체 동의"
              type="checkbox"
            />
            <p
              className="typography-semantic-label-1-normal---regular text-semantic-link-global-global-default cursor-pointer"
              onClick={handleTermsClick}
            >
              약관 보기
            </p>
          </div>
          <div className="pl-[16px] space-y-4">
            <div className="flex items-start gap-[24px] p-sp80">
              <div>
                <CheckboxSelectionControl
                  id={`${name}-personal-info`}
                  checked={terms?.personalInfo}
                  onChange={(checked) =>
                    handleCheckboxChange(`${name}.personalInfo`, checked)
                  }
                  label="개인정보 필수항목 수집 및 이용 동의"
                  required
                  requiredMessage
                />
                <input
                  type="checkbox"
                  className="hidden"
                  {...register(`${name}.personalInfo`, {
                    required: "필수 입력 사항 입니다.",
                    invalid_type_error: "필수 입력 사항 입니다.",
                  })}
                />
              </div>
              {errors[name]?.personalInfo && (
                <Helper
                  size="md"
                  state="error"
                  className="typography-semantic-body-2-regular"
                  message={errors[name].personalInfo.message}
                />
              )}
            </div>
            <div className="flex items-start gap-2 p-sp80">
              <div>
                <CheckboxSelectionControl
                  id={`${name}-optional-info`}
                  checked={terms?.optionalInfo}
                  onChange={(checked) =>
                    handleCheckboxChange(`${name}.optionalInfo`, checked)
                  }
                  label="개인정보 선택항목 수집 및 이용 동의"
                  requiredMessage
                />
                <input
                  type="checkbox"
                  className="hidden"
                  {...register(`${name}.optionalInfo`)}
                />
              </div>
            </div>
            <div className="flex items-start gap-[24px] p-sp80">
              <div>
                <CheckboxSelectionControl
                  id={`${name}-sensitive-info`}
                  checked={terms?.sensitiveInfo}
                  onChange={(checked) =>
                    handleCheckboxChange(`${name}.sensitiveInfo`, checked)
                  }
                  label="민감정보 수집 및 이용 동의"
                  required
                  requiredMessage
                />
                <input
                  type="checkbox"
                  className="hidden"
                  {...register(`${name}.sensitiveInfo`)}
                />
              </div>
              {errors[name]?.sensitiveInfo && (
                <Helper
                  size="md"
                  state="error"
                  className="typography-semantic-body-2-regular"
                  message={errors[name].sensitiveInfo.message}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export { ApplyTerms };
